const Layout2 = ({ applicant }) => {
    return (
        <>
            <div className='RegisteredApplicant__Info'>
                <p className='RegisteredApplicant__Info__Text--Highlight'>PROCESO PARA APLICAR EL EXAMEN DE ADMISIÓN:</p>
                <ol className='RegisteredApplicant__Info__OrderedList'>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Acudir el día del examen a la escuela normal a presentar tu examen.</li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Ingresa a <a href='https://riactivos.com' className='RegisteredApplicant__Info__Text--Link'>https://riactivos.com</a></li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Escribe tu código de acceso.</li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Valida tus datos y aplica los exámenes correspondientes.</li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Consulta con la escuela normal la fecha y lugar de aplicación del examen.</li>
                </ol>
            </div>
        </>
    )
}

export { Layout2 };